import { ApiProperty } from "@nestjs/swagger"

export class TeamDto {

    @ApiProperty()
    id:number;

    @ApiProperty()
    shiftCode:string;

    @ApiProperty()
    isActive:boolean;

    @ApiProperty()
    createdAt:Date;

    @ApiProperty()
    createdUser:string;

    @ApiProperty()
    updatedAt:Date;

    @ApiProperty()
    updatedUser:string;

    @ApiProperty()
    versionFlag:number;
    


}